import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";

function ProductsPage() {
  const { productApi, productsApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(productsApi);
  const [filteredData, setFilteredData] = useState({});

  // filter by slug
  useEffect(() => {
    setFilteredData(
      apiData.filter((item) => !!item.slug && item.slug === "products")[0]
    );
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { productSectionDes, productSectionTitle, _id } = filteredData ?? {};

  // Form data
  const data = [
    {
      elementType: "textField",
      label: "Product section Title",
      type: "Text",
      name: "productSectionTitle",
      defaultValue: productSectionTitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "Product section Description",
      type: "Text",
      name: "productSectionDes",
      defaultValue: productSectionDes,
      required: false,
    },
  ];

  const update = (data) => {
    updateData(productApi, data, _id);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default ProductsPage;
